import BaseApi from "./baseApi";

export default class OrderAPI extends BaseApi {
    async cancelOrder(id: string): Promise<boolean> {
        const url = "/api/order/order";
        return await this.fetchDelete(url);
    }

    async getOrders(
        filter: OrderFilter,
        signal?: AbortSignal
    ): Promise<{ orders: Order[]; pageCount: number }> {
        const url = "/api/order/orders";
        return await this.fetchPost(url, filter, signal);
    }
    async getReviewOrders(
        filter: ReviewOrderFilter,
        signal?: AbortSignal
    ): Promise<{ orders: Order[]; pageCount: number }> {
        const url = "/api/revieworder/orders";
        return await this.fetchPost(url, filter, signal);
    }

    async postOrder(state: Order): Promise<Order> {
        const url = "/api/order/order";
        return await this.fetchPost(url, state);
    }

    async getOrder(orderId: string): Promise<Order> {
        const url = `/api/order/order/${orderId}`;
        return await this.fetchGet(url);
    }

    async updateOrder(state: Order): Promise<Order> {
        const url = "/api/order/order";
        return await this.fetchPut(url, state);
    }

    async getMobileServiceOrders(
        departmentIds: string[],
        days: number[]
    ): Promise<{ orders: Order[] }> {
        const url = "/api/order/mobileserviceorders";
        return await this.fetchPost(url, {
            departmentIds: departmentIds,
            days: days
        });
    }

    async createMoreSaleOrder(orderId: string): Promise<Order> {
        const url = `/api/MoreSaleOrder/create/${orderId}`;
        return await this.fetchGet(url);
    }

    async SignCalibrationChallenges(orderId: string, file:Blob): Promise<string> {
        const url = `/api/SignedPDF/SignCalibrationChallenges/${orderId}`;
        const formData = new FormData();
        formData.append("file", file, "signed-document.pdf");
        return await this.fetchPutFile(url, formData);
    }
    async SignLoanCar(orderId: string, loanCarId: string, file:Blob): Promise<string> {
        const url = `/api/SignedPDF/SignLoanCar/${orderId}/${loanCarId}`;
        const formData = new FormData();
        formData.append("file", file, "signed-loanCar.pdf");
        return await this.fetchPutFile(url, formData);
    }

    async createLoanCarInsurance(orderId: string): Promise<Order> {
        const url = `/api/MoreSaleOrder/create/${orderId}/LoanCarInsurance`;
        return await this.fetchGet(url);
    }

    async getOfferOrder(regNumber: string): Promise<Order> {
        const url = `/api/offer/GetReleatedOffer/${regNumber}`;
        return await this.fetchGet(url);
    }

    async copyOrder(
        orderId: string,
        model: CopyOrderModel
    ): Promise<Order> {
        const url = `/api/order/copy/${orderId}`;
        return await this.fetchPost(url, model);
    }

    async createComplaint(
        orderId: string,
        model: CreateComplaintModel
    ): Promise<Order> {
        const url = `/api/Complaint/create/${orderId}`;
        return await this.fetchPost(url, model);
    }
}
